export const getUserName = (state) => state.sidebarReducer.userData.username;
